import DiscordIcon from "./images/icons/discord.svg?react";
import RedditIcon from "./images/icons/reddit.svg?react";
import XIcon from "./images/icons/x.svg?react";
import InstagramIcon from "./images/icons/instagram.svg?react";

export const SOCIALS = [
  {
    Icon: DiscordIcon,
    link: "https://discord.gg/w8fTWPn4Eb",
    title: "Discord",
  },
  {
    Icon: XIcon,
    link: "https://bit.ly/405Qdey",
    title: "X",
  },
  {
    Icon: InstagramIcon,
    link: "https://bit.ly/3naK6an",
    title: "Instagram",
  },
  {
    Icon: RedditIcon,
    link: "http://bit.ly/405rRS7",
    title: "Reddit",
  }
];
